// src/services/cartWishlistApi.js
//
// Thin axios wrapper for the logged-in cart & wishlist endpoints.
//
// The backend derives the user from the Bearer token (same convention as
// /api/users/user) — any userId in the body/query is ignored, so we don't send
// one. Line identity is productId + variant (name/sku); pass the variant as
// { name, sku } (or null for a no-variant line). Quantity is ABSOLUTE: the POST
// sets the quantity, it does not increment. Never send quantity: 0 — use
// remove().
import axios from 'axios';
import { BASE_URL } from '@/globals';

const authHeaders = (token) => (token ? { Authorization: `Bearer ${token}` } : {});

export const cartApi = {
  get: (token) =>
    axios.get(`${BASE_URL}/api/cart`, { headers: authHeaders(token) }),
  upsert: ({ productId, quantity, variant }, token) =>
    axios.post(
      `${BASE_URL}/api/cart`,
      { productId, quantity, variant },
      { headers: authHeaders(token) }
    ),
  remove: ({ productId, variant }, token) =>
    axios.post(
      `${BASE_URL}/api/cart/remove`,
      { productId, variant },
      { headers: authHeaders(token) }
    ),
};

export const wishlistApi = {
  get: (token) =>
    axios.get(`${BASE_URL}/api/wishlist`, { headers: authHeaders(token) }),
  add: ({ productId, variant }, token) =>
    axios.post(
      `${BASE_URL}/api/wishlist`,
      { productId, variant },
      { headers: authHeaders(token) }
    ),
  remove: ({ productId, variant }, token) =>
    axios.post(
      `${BASE_URL}/api/wishlist/remove`,
      { productId, variant },
      { headers: authHeaders(token) }
    ),
};
